import {Params} from '../../shared/variables'

export interface RFQLandingParams {
    shouldOpenForm: boolean
    promotionTag: string | null
}

/**
 * Reads from the query string whether the RFQ form has to be open on landing:
 * `showForm-app=1` opens it, `promo-app=<tag>` opens it for the promotion with
 * that form opening tag (e.g. `adv`, `crm`).
 *
 * @param search Query string of the page, e.g. `window.location.search`
 * @returns Whether to open the form and the promotion tag, if any
 */
export function getRFQLandingParams(search: string): RFQLandingParams {
    const searchParams = new URLSearchParams(search)
    const promotionTag = searchParams.get(Params.PROMOTION)?.trim() || null

    return {
        shouldOpenForm:
            searchParams.get(Params.SHOW_FORM) === '1' || Boolean(promotionTag),
        promotionTag,
    }
}
